import { Container } from '@mui/material';
import useSettings from '../../hooks/useSettings';
import Page from '../../components/Page';
import { useTranslations } from 'hooks/useTranslations';
import CovidPolicyStep3 from 'components/insurance/step-3/CovidPolicyStep3';
import { TravelCancellationPolicyStepper } from 'components/insurance/components/TravelCancellationPolicyStepper';

export default function TravelCancellationInsuranceStep3() {
  const translations = useTranslations();
  const { themeStretch } = useSettings();

  return (
    <Page title={translations.policy.travelCancellation.title()}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <TravelCancellationPolicyStepper heading={translations.policy.travelCancellation.title()} currentStep={2} />

        <CovidPolicyStep3 />
      </Container>
    </Page>
  );
}
